import styled from "styled-components";
import {ACTIVE} from "../../../../../../themes/css-global-classes";

export const PanicButtonBox = styled.div`
    width: 15.7rem;
    height: 2.7rem;

    &.${ACTIVE} {
      &::after{
        display: block;
      }
    }

    &::before {
        content: '';
        display: block;
        position: absolute;
        top: 3.9rem;
        width: 15rem;
        height: 0.8rem;
        background: transparent;
    }

    &::after{
        display: none;
        content: " ";
        position: relative;
        left: 3rem;
        top: -0.3rem;
        width: 1px;
        border-width: 5px;
        border-style: solid;
        border-color: transparent transparent ${({theme}) => theme.colors.backgroundContrast} transparent;

        @media ${({theme}) => theme.mediaQuery.sAndBelow}{
            @media ${({theme}) => theme.mediaQuery.portrait}{
                  left: 7.5rem;
            }
        }
    }
`;
